import { motion } from "framer-motion";
import React, { memo } from "react";
import { useLocation } from "react-router-dom";
import NavbarV3 from "../../components/NavbarV3/NavbarV3.tsx";
import "./layout.css";

function Layout({
	children,
	title,
	showNavbar = true,
}: {
	children: React.ReactNode;
	title?: string;
	showNavbar?: boolean;
}) {
	const pathname = useLocation().pathname;
	return (
		<motion.div
			key={pathname}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.5 }}
			className="layout-container"
		>
			{!!title && showNavbar && <NavbarV3 title={title} />}
			<div className="layout-content">{children}</div>
		</motion.div>
	);
}

export default memo(Layout);
